var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c("div", [
        _c(
          "div",
          { staticClass: "mr-t-15" },
          [
            [
              Object.keys(_vm.product.fnskus).length > 1
                ? _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.product.fnsku,
                          expression: "product.fnsku"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "bg-no-input": !_vm.product.fnsku },
                      attrs: {
                        disabled: _vm.isDisableEdit,
                        name: "fnsku-kbn",
                        id: "fnsku-kbn-select-" + _vm.product.asin
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.product,
                              "fnsku",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            _vm.changeFnsku()
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v("選択してください")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.product.fnskus, function(val, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: key } },
                          [_vm._v(_vm._s(val))]
                        )
                      })
                    ],
                    2
                  )
                : Object.keys(_vm.product.fnskus).length === 1
                ? _c("div", { staticClass: "m-t" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.product.fnsku) + "\n        "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.product.fnsku,
                          expression: "product.fnsku"
                        }
                      ],
                      attrs: { type: "hidden" },
                      domProps: { value: _vm.product.fnsku },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.product, "fnsku", $event.target.value)
                        }
                      }
                    })
                  ])
                : _c("div", { staticClass: "m-t" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.product.fnsku) + "\n      "
                    )
                  ])
            ]
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14a67ee0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a67ee0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/components/FnskuKbnItem.vue
// module id = null
// module chunks = 